import NavBar from '@/components/elements/navigation/navbar';
import Footer from '@/components/elements/navigation/footer';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className='flex h-screen flex-col'>
        <NavBar />
        <div className='grow px-3'>{children}</div>
        <Footer />
      </div>
    </>
  );
}
